import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getBusinessDetailsRequest: ["payload"], // payload: { params }
  getBusinessDetailsSuccess: ["payload"], // payload: { data }

  updateBusinessDetailsRequest: ["payload"], // payload: { data, params }
  updateBusinessDetailsSuccess: ["payload"], // payload: { data }

  getCountriesRequest: ["payload"], // payload: { params },
  getCountriesSuccess: ["payload"], // payload: { countries }

  logout: null
})

export const BusinessDetailsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  businessDetails: null,
  countries: []
})

/* ------------- Functions for reducer cases ------------- */
const getBusinessDetailsRequest = (state) => state.merge({ fetching: true })
const getBusinessDetailsSuccess = (state, { payload }) => {
  return state.merge({
    businessDetails: payload?.results?.[0] ?? null
  })
}

const updateBusinessDetailsRequest = (state) => state.merge({ fetching: true })
const updateBusinessDetailsSuccess = (state, { payload }) =>
  state.merge({
    businessDetails: payload
  })

const getCountriesRequest = (state) => state
const getCountriesSuccess = (state, { payload }) =>
  state.merge({
    countries: payload
  })

const logout = (state) => INITIAL_STATE

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_BUSINESS_DETAILS_REQUEST]: getBusinessDetailsRequest,
  [Types.GET_BUSINESS_DETAILS_SUCCESS]: getBusinessDetailsSuccess,

  [Types.UPDATE_BUSINESS_DETAILS_REQUEST]: updateBusinessDetailsRequest,
  [Types.UPDATE_BUSINESS_DETAILS_SUCCESS]: updateBusinessDetailsSuccess,

  [Types.GET_COUNTRIES_REQUEST]: getCountriesRequest,
  [Types.GET_COUNTRIES_SUCCESS]: getCountriesSuccess,

  [Types.LOGOUT]: logout
})
